import React, { useEffect, useState } from 'react';

import './index.css';

function OverviewEmpty() {
    return (
        <div className='class__overviewEmpty'>
            No test has been assigned.
        </div>
    );
}

export default OverviewEmpty;